export enum UserRewardsQueryKeys {
  Primary = '/user-rewards',
  Me = '/user-rewards/me',
  Trackers = '/user-rewards/trackers',
  ById = '/user-rewards/:id',
}
